import {
  Component,
  OnDestroy,
  Inject,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  SuiModal,
  SuiModalService,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { CompanyService, DocumentService } from '../../services';
import { AuthenticationService } from 'src/modules/core/services';
import { OrganizationService } from 'src/modules/features/contractor/services';
interface INewDirectorModalContext {
  data?: any;
  title?: string;
  isEdit?: boolean;
}
@Component({
  selector: 'app-new-director-modal',
  templateUrl: './new-director-modal.component.html',
  styleUrls: ['./new-director-modal.component.scss'],
})
export class NewDirectorModalComponent implements OnInit, OnDestroy {
  @ViewChild('input') input: ElementRef;
  @ViewChild('uploadDoc') uploadDoc: ElementRef;
  searchable: boolean = true;
  public mode: DatepickerMode = 'year';
  public maxDate = new Date();
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pendingArr: boolean[] = [];

  companyDirectorForm: FormGroup;
  companyDirector: any;

  companyType: Array<any> = [];
  ownershipType: Array<any> = [];
  countries: Array<any> = [];
  organizationId: string;
  currentForm: any;
  changeRequestId: string;
  heading: string;
  documentForm: FormGroup;
  selectedFile;
  fileNameArr: any = {};
  allFiles = [];
  uploadFormData: any;
  fileError;
  constructor(
    private companySvc: CompanyService,
    private modalService: SuiModalService,
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,

    private authSvc: AuthenticationService,
    private organizationSvc: OrganizationService,
    public modal: SuiModal<INewDirectorModalContext, void, void>,
    private documentSvc: DocumentService
  ) {
    this.heading =
      modal.context.data.item == 'SHAREHOLDER_STRUCTURE'
        ? 'Shareholder'
        : 'Director';
    this.companyType = modal.context.data.companyType;
    this.countries = modal.context.data.countries;
    this.ownershipType = modal.context.data.ownershipType;
    this.organizationId = window.localStorage.getItem('organizationId');

    this.companyDirectorForm = fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      middleName: [''],
      gender: ['', Validators.required],
      nationalityId: ['', Validators.required],
      countryOfOriginId: ['', Validators.required],
      nationalIdNumber: ['', Validators.required],
      organizationOwnershipTypeId: [''],
      organizationOwnershipId: [''],
      shareholding: [0, Validators.required],
      actionType: [''],
    });
    this.documentForm = this.fb.group({
      file: [''],
      documentName: ['Doc', Validators.required],
      documentDescription: ['supporting document'],
      documentTypeId: ['CHANGE_REQUEST_DOCUMENT'],
      documents: this.fb.array([]),
    });
    if (modal.context.isEdit) {
      this.companyDirector = modal.context.data.director;
      this.companyDirectorForm.patchValue(this.companyDirector);
    }
    this.currentForm = this.companyDirectorForm.value;
  }
  get documents() {
    return this.documentForm.controls['documents'] as FormArray;
  }
  removeDocSegment(index: number) {
    this.documents.removeAt(index);
  }
  isFieldValid(field: string) {
    return (
      (!this.companyDirectorForm.get(field).valid &&
        this.companyDirectorForm.get(field).touched) ||
      (this.companyDirectorForm.get(field).untouched && this.formSubmitAttempt)
    );
    return (
      (!this.documentForm.get(field).valid &&
        this.documentForm.get(field).touched) ||
      (this.documentForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }

  submit() {
    this.modal.context.isEdit == true
      ? this.updateDirector('UPDATE')
      : this.save();
  }

  printForm() {
    console.log(this.companyDirectorForm.valid, this.companyDirectorForm.value);
  }

  save() {
    this.formSubmitAttempt = false;
    if (this.companyDirectorForm.valid) {
      this.callStarted();
      let data = this.companyDirectorForm.value;
      data['organizationId'] = this.organizationId;
      this.companySvc
        .addCompanyDirector({
          organizationId: this.organizationId,
          body: data,
        })
        .subscribe(
          (res) => {
            this.callCompleted();
            this.success = 'Company director added successfully';
            setTimeout(() => {
              this.modal.approve(null);
            }, 2000);
          },
          (error) => {
            this.callCompleted();
            this.error = error.error.errorMessage
              ? error.error.errorMessage
              : error.error
              ? error.error
              : error;
          }
        );
    } else {
      this.formSubmitAttempt = true;
    }
  }

  update() {
    this.formSubmitAttempt = false;
    if (this.companyDirectorForm.valid) {
      this.callStarted();
      let data = this.companyDirectorForm.value;
      data['organizationId'] = this.organizationId;
      this.companySvc
        .updateCompanyDirector({
          organizationId: this.organizationId,
          id: this.companyDirector.organizationOwnershipId,
          body: { ...this.companyDirector, ...data },
        })
        .subscribe(
          (res) => {
            this.callCompleted();
            this.success = 'Company director updated successfully';
            setTimeout(() => {
              this.modal.approve(null);
            }, 2000);
          },
          (error) => {
            this.callCompleted();
            this.error = error.error.errorMessage
              ? error.error.errorMessage
              : error.error
              ? error.error
              : error;
          }
        );
    } else {
      this.formSubmitAttempt = true;
    }
  }

  // update form
  updateDirector(val) {
    if (this.selectedFile) {
      val = this.modal.context.isEdit ? 'UPDATE' : 'ADD';
      let organizationId = window.localStorage.getItem('organizationId');
      this.callStarted();
      this.companyDirectorForm.value.actionType = val;
      this.currentForm.actionType = val;
      if (
        this.modal.context.data.item == 'shareholder' ||
        this.modal.context.data.item == 'SHAREHOLDER_STRUCTURE'
      ) {
      } else {
        this.companyDirectorForm.value.shareholding = '0';
        this.currentForm.shareholding = '0';
      }
      this.nullify();
      let payload = {
        fromValue: this.currentForm,
        toValue: this.companyDirectorForm.value,
      };
      console.log(payload);
      this.submitDoc(payload);
      // this.organizationSvc
      //   .addChangeRequest({
      //     organizationId: organizationId,
      //     body: payload,
      //   })
      //   .subscribe(
      //     (res) => {
      //       this.changeRequestId = res['changeRequestId'];
      //       this.input.nativeElement.focus();
      //       this.submitDoc();
      //     },
      //     (error) => {
      //       this.callCompleted();
      //       this.error = error.error;
      //     }
      //   );
    } else {
      this.input.nativeElement.focus();
      this.error = 'Please upload a supporting document';
    }

    this.callCompleted();
  }

  nullify() {
    this.success = null;
    this.error = null;
  }
  createDocument() {
    const docForm = this.fb.group({
      document: [null, Validators.required],
    });

    this.documents.push(docForm);
    this.uploadDoc.nativeElement.focus();
  }
  onFileChange(event, ind) {
    const files = event.target.files;
    if (!files) {
      return;
    }
    this.selectedFile = files[0];
    this.fileNameArr[ind] = this.selectedFile['name'];
    this.allFiles.push(this.selectedFile);
  }
  submitDoc(response) {
    this.formSubmitAttempt = false;
    if (this.fileError == null) {
      let data: any = this.documentForm.value;
      // this.allFiles.map(file => {})
      const formData: FormData = new FormData();
      formData.append('file', this.selectedFile, this.selectedFile.name);
      let payload: any = { formValue: data, formData: formData };
      // this.modal.approve(payload);

      this.uploadFormData = payload['formData'];
      const values = payload['formValue'];
      const jsonse = JSON.stringify(values);
      const blob = new Blob([jsonse], { type: 'application/json' });
      this.uploadFormData.append('data', blob);
      this.onUploadFile(this.uploadFormData, response);
    } else {
      this.formSubmitAttempt = true;
    }
  }

  onUploadFile(data, response) {
    this.nullify();
    this.callStarted();
    let result: any = {
      fromValue: response.fromValue,
      toValue: response.toValue,
      document: data,
    };
    this.input.nativeElement.focus();
    this.success =
      'Update Successful. Ensure you save so that the request can undergo verification';
    setTimeout(() => {
      this.modal.approve(result);
    }, 2000);
    this.callCompleted();
  }
  ngOnInit() {
    // this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }

  callStarted() {
    this.pendingArr.push(true);
  }

  callCompleted() {
    this.pendingArr.pop();
  }
}

export class NewDirectorModal extends ComponentModalConfig<
  INewDirectorModalContext,
  void,
  void
> {
  constructor(
    title: string,
    data: any,
    isEdit: boolean,
    size: ModalSize = ModalSize.Tiny
  ) {
    super(NewDirectorModalComponent, { title, data, isEdit });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
